import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import { AsyncValidationsActions, AsyncValidationsActionTypes } from '../actions/async-validations.action';
import { ValidationsFormValues } from '../models/form-values';

export interface State {
  forms: any;
}

export const initialState: State = {
  forms: [],
};
export let formCounter = -1;

/**
 * Adds an item to the recipe
 */
const makeRecipeItem = (values: { [key: string]: any }): ValidationsFormValues => {
  const id = ++formCounter;
  return {
    id: id,
    values: { ...values },
  };
};
export function reducer(state = initialState, action: AsyncValidationsActions | OrderBuilderActions): State {
  switch (action.type) {
    case RESET_BUILDER:
    case AsyncValidationsActionTypes.RESET: {
      formCounter = -1;
      return {
        ...initialState,
      };
    }
    case AsyncValidationsActionTypes.ADD_ITEM: {
      return {
        ...state,
        forms: [...state.forms, makeRecipeItem({})],
      };
    }
    case AsyncValidationsActionTypes.REMOVE_ITEM: {
      return {
        ...state,
        forms: state.forms.filter(i => i.id !== action.payload),
      };
    }
    case AsyncValidationsActionTypes.SET_PURCHASE_ORDER_VALIDATING: {
      return {
        ...state,
        forms: state.forms.map(item => {
          if (item.id === action.payload.formId) {
            return {
              ...item,
              purchaseOrderValidating: action.payload.purchaseOrderValidating,
            };
          } else {
            return item;
          }
        }),
      };
    }
    case AsyncValidationsActionTypes.SET_PURCHASE_ORDER_VALID: {
      return {
        ...state,
        forms: state.forms.map(item => {
          if (item.id === action.payload.formId) {
            return {
              ...item,
              purchaseOrderValid: action.payload.purchaseOrderValid,
            };
          } else {
            return item;
          }
        }),
      };
    }
    case AsyncValidationsActionTypes.SET_REPEAT_PURCHASE_ORDER_VALID: {
      return {
        ...state,
        forms: state.forms.map(item => {
          if (item.id === state.forms.length - 1) {
            return {
              ...item,
              purchaseOrderValid: true,
            };
          } else {
            return item;
          }
        }),
      };
    }
    default: {
      return state;
    }
  }
}
